import { collectOffsetPages } from '../../shared/collectOffsetPages';
import { ApiError, type ApiClient } from '../../api/client';
import type {
  HeadcountChange,
  HeadcountCollection,
  HeadcountPort,
  HeadcountPosition,
  HeadcountPositionChangeInput,
  HeadcountPositionCreateInput,
} from '../../features/headcount/public';

const positionPageSize = 100;

async function listAllPositions(client: ApiClient, organizationId: string, asOf: string): Promise<HeadcountCollection<HeadcountPosition>> {
  return collectOffsetPages((offset) => {
    const query = new URLSearchParams({ limit: String(positionPageSize), offset: String(offset) });
    if (organizationId) query.set('organizationId', organizationId);
    if (asOf) query.set('asOf', asOf);
    return client.requestTenant<HeadcountCollection<HeadcountPosition>>(`/api/hr/v1/{tenant}/positions?${query}`);
  }, positionPageSize);
}

export function createHeadcountHttpAdapter(client: ApiClient): HeadcountPort {
  return {
    listPositions(organizationId = '', asOf = '') {
      return listAllPositions(client, organizationId, asOf);
    },

    createPosition(input: HeadcountPositionCreateInput, idempotencyKey: string) {
      return client.requestTenant<HeadcountChange>('/api/hr/v1/{tenant}/positions', {
        method: 'POST',
        headers: { 'Idempotency-Key': idempotencyKey },
        body: JSON.stringify(input),
      });
    },

    changePosition(positionId: string, input: HeadcountPositionChangeInput, idempotencyKey: string) {
      return client.requestTenant<HeadcountChange>(`/api/hr/v1/{tenant}/positions/${encodeURIComponent(positionId)}/changes`, {
        method: 'POST',
        headers: { 'Idempotency-Key': idempotencyKey },
        body: JSON.stringify(input),
      });
    },

    submitHeadcountChange(changeId: string, idempotencyKey: string) {
      return client.requestTenant<HeadcountChange>(`/api/hr/v1/{tenant}/positionHeadcountChanges/${encodeURIComponent(changeId)}/submit`, {
        method: 'POST',
        headers: { 'Idempotency-Key': idempotencyKey },
        body: '{}',
      });
    },

    isDefinitiveMutationFailure(cause: unknown) {
      return cause instanceof ApiError;
    },
  };
}
